import { useTranslation } from 'react-i18next'

import { CoinsIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import { TitleContainer } from '../styles'
import ExportCountryBlock from './ExportCountryBlock/ExportCountryBlock'
import { getExportPriceByCountry, updateExportPrice } from './helpers'
import * as Styles from './styles'

const ExportPrices = ({
  exportBlocks,
  exportPrices,
  taricCode,
  manufacturerName,
  manufacturerAddress,
  onChangeTaricCode,
  onChangeManufacturer,
  onChange,
  currencies,
  hsCode,
}) => {
  const { t } = useTranslation()

  const handleChangeExportPrice = (countryCode, field, value) => {
    onChange(updateExportPrice(exportPrices, countryCode, field, value))
  }

  return (
    <Styles.Container>
      <TitleContainer>
        <CoinsIcon size={24} weight="light" />
        <Text type="bodyMBold">{t('Información de exportación')}</Text>
      </TitleContainer>
      {exportBlocks.map(block => (
        <ExportCountryBlock
          key={block.code}
          block={block}
          exportPrice={getExportPriceByCountry(exportPrices, block.code)}
          taricCode={taricCode}
          hsCode={hsCode}
          currencies={currencies}
          manufacturerName={manufacturerName}
          manufacturerAddress={manufacturerAddress}
          onChange={(field, value) => handleChangeExportPrice(block.code, field, value)}
          onChangeTaricCode={onChangeTaricCode}
          onChangeManufacturer={onChangeManufacturer}
        />
      ))}
    </Styles.Container>
  )
}

export default ExportPrices
